import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt, FaSearch, FaArrowRight } from 'react-icons/fa';
import './ProjectsPage.css';

const ProjectsPage = () => {
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = ['all', 'web', 'mobile', 'ai', 'cloud'];

  const projects = [
    {
      id: 1,
      title: 'Company Portfolio & Internship System (Shiwansh)',
      category: 'web',
      image: '/images/shi.png',
      description: 'Corporate website with internship application system, service showcase, and lead generation features.',
      technologies: ['React', 'Bootstrap', 'Node.js', 'MongoDB'],
      live: 'https://www.shiwansh.com/'
    },
    {
      id: 2,
      title: 'Ramkus Dairy Website',
      category: 'web',
      image: '/images/ram.png',
      description: 'A modern dairy business website with product showcase, online ordering, and delivery information for local customers.',
      technologies: ['React', 'Tailwind CSS', 'Node.js'],
      live: 'https://ramkusdairy.shop/'
    },
    {
  id: 3,
  title: 'NSGO India - National Scouts & Guides Organization',
  category: 'web',
  image: '/images/ngo1.png',
  description: 'Official website of NSGO India, a national and international organization focused on youth empowerment, leadership development, community service, disaster relief, environmental initiatives, and volunteer development.',
  technologies: ['Next.js', 'Node.js', 'MongoDB'],
  live: 'https://nsgoindiaintl.org/'
},
    {
      id: 4,
      title: 'Employee Management System (EMS)',
      category: 'web',
      image: '/images/ems.png',
      description: 'Secure employee management platform with login system, productivity tracking, and internal workflow management.',
      technologies: ['React', 'Node.js', 'Express', 'MySQL'],
      live: 'https://ems.shiwansh.com/'
    },
    {
      id: 5,
      title: 'DBK Infra Website',
      category: 'web',
      image: '/images/dhk.png',
      description: 'Corporate infrastructure website focused on branding, services, and company portfolio presentation.',
      technologies: ['React', 'Bootstrap', 'Node.js'],
      live: 'https://dbkinfra.com/'
    },
  
    // 🔥 PRODUCTS / TOOLS
  
    {
      id: 6,
      title: 'ZustandTech Smart Billing System',
      category: 'web',
      image: '/images/ztb.png',
      description: 'Smart billing solution for businesses with invoice generation, GST support, customer management, and real-time reports.',
      technologies: ['React', 'Node.js', 'MongoDB', 'Express'],
      live: 'https://www.billingzustandtech.com'
    },
    {
      id: 7,
      title: 'Pneumonia Detection AI Tool',
      category: 'ai',
      image: '/images/zt.png',
      description: 'AI-powered medical tool that analyzes chest X-rays using deep learning (CNN + Grad-CAM) to detect pneumonia.',
      technologies: ['Python', 'TensorFlow', 'Flask', 'React'],
      live: 'https://www.x-rayzustandtech.com'
    },
    {
      id: 8,
      title: 'Solar Project Analytics Dashboard',
      category: 'ai',
      image: '/images/so.png',
      description: 'Advanced analytics dashboard for solar project financials, expense tracking, and performance insights.',
      technologies: ['Power BI', 'DAX', 'Excel', 'SQL'],
      live: ''
    },
  
    // 🔧 OTHER PROJECTS
  
    {
      id: 9,
      title: 'Sanhai Charitable Trust',
      category: 'web',
      image: '/images/shan.png',
      description: 'Compassion in Action, Hope for All — Empowering education, rescuing animals, greening earth, and healing lives. Join the movement of change that transforms communities.',
      technologies: ['React', 'Bootstrap', 'Node.js', 'Express', 'MongoDB'],
      stats: [
        { label: 'Years of Service', value: '10+' },
        { label: 'Lives Impacted', value: '50,000+' },
        { label: 'Volunteers', value: '500+' },
        { label: 'Villages Reached', value: '100+' }
      ],
      features: ['Education', 'Animal Rescue', 'Plantation', 'Medical Camps', 'Fostering'],
      live: 'https://peppy-cat-8742f6.netlify.app'
    },
    {
      id: 10,
      title: 'Rent A Guava Tree',
      category: 'web',
      image: '/images/gua.png',
      description: 'Sustainable farming — Lease your own guava tree for ₹5,000 per season and receive 30-90 kg of fresh, chemical-free guavas delivered to your doorstep.',
      technologies: ['React', 'Node.js', 'MongoDB', 'Razorpay', 'Twilio'],
      highlights: [
        '₹5,000 per season',
        '30-90 kg guavas',
        'Chemical-free farming',
        'Home delivery included'
      ],
      metrics: {
        treesLeased: '500+',
        activePartners: '50+',
        totalHarvest: '10,000+ kg'
      },
      live: 'https://rent-guava.netlify.app'
    },
    {
      id: 11,
      title: 'City Bus Booking System',
      category: 'web',
      image: '/images/bus.png',
      description: 'Online bus booking and management system with user registration, route tracking, and ticket booking.',
      technologies: ['React', 'Node.js', 'MongoDB'],
      live: ''
    },
    {
      id: 12,
      title: 'Weather Analytics Dashboard',
      category: 'ai',
      image: '/images/we.png',
      description: 'Weather dashboard displaying real-time conditions, forecasts, and air quality metrics with data visualization.',
      technologies: ['React', 'API Integration', 'Chart.js'],
      live: 'https://weatherdashboardlatticee.netlify.app/'
    },
    {
      id: 13,
      title: 'NGO Education Website',
      category: 'web',
      image: '/images/ngo.png',
      description: 'Website for an NGO showcasing events, competitions, and educational initiatives with gallery and updates.',
      technologies: ['React', 'Bootstrap', 'Node.js'],
      live: ''
    },

    // 🆕 NEW PROJECTS

    {
      id: 14,
      title: 'BloodBank Management System',
      category: 'cloud',
      image: '/images/bloodbank.png',
      description: 'Multi-tenant donor, inventory, and dispatch management platform for blood banks, built for compliance and full donor-to-patient traceability.',
      technologies: ['React', 'Node.js', 'MongoDB'],
      live: 'https://bloodbank.zustandtech.com/'
    },
    {
      id: 15,
      title: 'ZustPDF - Online PDF Tools',
      category: 'web',
      image: '/images/zustpdf.png',
      description: 'Merge, split, compress, edit, and convert PDFs online for free - 20+ browser-based PDF tools that run entirely client-side with no upload or sign-up required.',
      technologies: ['React', 'JavaScript', 'PDF-lib'],
      live: 'https://pdf.zustandtech.com/'
    },
    {
      id: 16,
      title: 'Kanha Shyamm - Sweets & Bakery',
      category: 'web',
      image: '/images/kanha-shyamm.png',
      description: "Gorakhpur's favourite stop for fresh sweets, crispy snacks, and celebration cakes, baked and packed fresh with online ordering and catalogue.",
      technologies: ['React', 'Node.js'],
      live: 'https://kanha-shyamm.netlify.app/'
    }
  ];

  const filteredProjects = projects.filter(project => {
    const matchesCategory = filter === 'all' || project.category === filter;
    const matchesSearch = project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="projects-page"
    >
      <section className="projects-filter-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="page-heading"
          >
            <h1>Our <span className="gradient-text">Projects</span></h1>
            <p>Explore our portfolio of innovative software solutions</p>
          </motion.div>
          
          <div className="filter-controls">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search projects..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            
            <div className="category-filters">
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`filter-btn ${filter === cat ? 'active' : ''}`}
                  onClick={() => setFilter(cat)}
                >
                  {cat.charAt(0).toUpperCase() + cat.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="projects-gallery">
        <div className="container">
          <AnimatePresence mode="wait">
            <motion.div
              key={filter + searchTerm}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="projects-grid-full"
            >
              {filteredProjects.map((project, index) => (
                <motion.div
                  key={project.id}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  className="project-full-card"
                >
                  <div className="project-full-image">
                    <img src={project.image} alt={project.title} />
                    <div className="project-full-overlay">
                      <div className="project-full-links">
                        {project.live && (
                          <a href={project.live} target="_blank" rel="noopener noreferrer">
                            <FaExternalLinkAlt /> Live Demo
                          </a>
                        )}
                      </div>
                    </div>
                    <span className="project-full-category">{project.category}</span>
                  </div>
                  <div className="project-full-content">
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <div className="project-full-tech">
                      {project.technologies.map((tech, i) => (
                        <span key={i}>{tech}</span>
                      ))}
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </AnimatePresence>

          {filteredProjects.length === 0 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="no-projects"
            >
              <h3>No projects found</h3>
              <p>Try adjusting your search or filter criteria</p>
            </motion.div>
          )}
        </div>
      </section>

      <section className="page-cta-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="page-cta-content"
          >
            <h2>GET IN TOUCH</h2>
            <h3>Let's Connect</h3>
            <p>Ready to start your next project? Reach out to us and let's discuss how we can help.</p>
            <Link to="/contact" className="cta-button">
              Contact Us <FaArrowRight />
            </Link>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default ProjectsPage;